export default () => {
  const config = useRuntimeConfig();
  const storageKey = config.public.local_storage_key;

  function getKey(key: string): string {
    return `${storageKey}-${key}`;
  }

  /**
   * Store a value.
   *
   * @param key
   * @param value
   */
  function setItem(key: string, value: any) {
    localStorage.setItem(getKey(key), JSON.stringify(value))
  }

  /**
   * Get value from selected item.
   *
   * @param key
   */
  function getItem(key: string) {
    const value = localStorage.getItem(getKey(key));

    return value
      ? JSON.parse(value)
      : null;
  }

  /**
   * Remove selected item.
   *
   * @param key
   */
  function removeItem(key: string) {
    if (localStorage.getItem(getKey(key)) !== null) {
      localStorage.removeItem(getKey(key));
    }
  }

  return {
    setItem,
    getItem,
    removeItem
  }
}
